import { useCarbarStore } from '@/stores/carbar'

interface MenuItem {
	showMegaMenu?: boolean
	megaMenuState?: 'shown' | 'hidden'
	hideMegaMenuInterval?: number
	hideMegaMenuTimeout?: number
	key?: string
}

interface HeaderModule {
	toggleMobileMenu: () => void
	hideMobileMenu: () => void
	showMobileMenu: () => void
	onMegaMenuMouseOver: (menuItem: MenuItem) => void
	onMegaMenuMouseLeave: (menuItem: MenuItem) => void
	showMegaMenu: (menuItem: MenuItem) => void
	hideMegaMenu: (menuItem: MenuItem) => void
	hideAllMegaMenu: (menu: MenuItem[], excludeMenuKeys?: string[]) => void
	onMegaMenuLinkClick: (
		megaMenu: MenuItem,
		type?: string | null,
		label?: string | null,
		category?: string | null
	) => void
}

export const headerModule = (): HeaderModule => {
	const carbar = () => useCarbarStore()

	const toggleMobileMenu = () => {
		if (carbar().header.showMobileMenu) {
			hideMobileMenu()
			window.zE?.show()
		} else {
			showMobileMenu()
			window.zE?.hide()
		}
	}

	const hideMobileMenu = () => {
		if (!carbar().header.showMobileMenu) {
			return
		}

		carbar().header.showMobileMenu = false

		document.body.classList.remove(...['mobile-menu-active'])
		document.documentElement.classList.remove('disable-scroll')
	}

	const showMobileMenu = () => {
		if (carbar().header.showMobileMenu) {
			return
		}

		carbar().header.showMobileMenu = true

		document.body.classList.add(...['mobile-menu-active'])
		document.documentElement.classList.add('disable-scroll')
	}

	const onMegaMenuMouseOver = (menuItem: MenuItem) => {
		showMegaMenu(menuItem)
	}

	const onMegaMenuMouseLeave = (menuItem: MenuItem) => {
		hideMegaMenu(menuItem)
	}

	const showMegaMenu = (menuItem: MenuItem) => {
		if (typeof menuItem.showMegaMenu === 'undefined') return

		// when force closing mega menu, bail
		if (
			menuItem.hideMegaMenuInterval &&
			menuItem.hideMegaMenuTimeout === 0
		) {
			return
		}
		menuItem.showMegaMenu = true
		menuItem.megaMenuState = 'shown'
	}

	const hideMegaMenu = (menuItem: MenuItem) => {
		if (typeof menuItem.showMegaMenu === 'undefined') return
		menuItem.showMegaMenu = false
		menuItem.megaMenuState = 'hidden'
	}

	const hideAllMegaMenu = (
		menu: MenuItem[],
		excludeMenuKeys: string[] = []
	) => {
		menu.forEach((menuItem) => {
			if (typeof menuItem.showMegaMenu === 'undefined') return

			if (excludeMenuKeys.includes(menuItem.key || '')) return

			menuItem.megaMenuState = 'hidden'
			menuItem.showMegaMenu = false
		})
	}

	const onMegaMenuLinkClick = (
		megaMenu: MenuItem,
		type: string | null = null,
		label: string | null = null,
		category: string | null = null
	): void => {
		hideMegaMenu(megaMenu)
		hideMobileMenu()
		if (type !== null) {
			gtmTrack(type, label, category)
		}
	}

	const gtmTrack = (
		type: string,
		label: string | null,
		category: string | null
	) => {
		trackGtmEvent({
			event: 'popular_search',
			product_category: category,
			popular_search_type: type,
			popular_search_selection: label,
			engagement_location: 'Header',
		})
	}

	return {
		toggleMobileMenu,
		hideMobileMenu,
		showMobileMenu,
		onMegaMenuMouseOver,
		onMegaMenuMouseLeave,
		showMegaMenu,
		hideMegaMenu,
		hideAllMegaMenu,
		onMegaMenuLinkClick,
	}
}
